const ANALYSIS_SPEED_RATIO = 0.55;
const SLOWDOWN = 1 / ANALYSIS_SPEED_RATIO;

const BASE_CHEMISTRY_ANALYSIS_TIMELINE = [
  { id: 'intro', start: 0, end: 1000 },
  { id: 'scanA', start: 1000, end: 2400 },
  { id: 'scanB', start: 2400, end: 3800 },
  { id: 'compare', start: 3800, end: 5400 },
  { id: 'direction', start: 5400, end: 6800 },
  { id: 'score', start: 6800, end: 8200 },
];

export const CHEMISTRY_ANALYSIS_TIMELINE = BASE_CHEMISTRY_ANALYSIS_TIMELINE.map((scene) => ({
  ...scene,
  start: Math.round(scene.start * SLOWDOWN),
  end: Math.round(scene.end * SLOWDOWN),
}));

export const CHEMISTRY_ANALYSIS_TOTAL_MS = Math.round(9000 * SLOWDOWN);
export const CHEMISTRY_ANALYSIS_REDUCED_MS = 850;

export function getSceneAtElapsed(elapsedMs, timeline = CHEMISTRY_ANALYSIS_TIMELINE) {
  return timeline.find((scene) => elapsedMs >= scene.start && elapsedMs < scene.end) || timeline[timeline.length - 1];
}
